module.exports = __webpack_public_path__ + "img/icon_file_del.59c16de4.svg";